module.exports = __webpack_public_path__ + "img/banner1.c2debee3.png";